const LitterInfoOk = {
  SET_LITTER_INFO_OK: 'SET_LITTER_INFO_OK',
};

export default LitterInfoOk;
